export default __webpack_public_path__ + "static/media/shopping_cart_active.380591b0.svg";